import BFFAPI from './utils/BFFAPI';

class RolesAPI extends BFFAPI {
  getUserManagementSubmenu = () => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}/menu`);
    return this.fetch(req);
  };
}

export default new RolesAPI('/fleet/secure/roles');
